<template>
    <div class="w-full h-full">
        <slot></slot>
    </div>
</template>

<script>

export default {

    name: "IntegrationLayout",

    components: {

    },

    data() {
        return {

        }
    },

    created: function () {

    },

    beforeUnmount() {

    },

    methods: {

    }
}

</script>
